
  import { Component, Prop, Vue } from 'vue-property-decorator';
  import { Getter } from 'vuex-class';

  import Entity from '@/src/types/entities/entity';

  @Component({})
  export default class EntityName extends Vue {
    @Getter('getEntity', { namespace: 'entity' }) entity!: Entity;
    @Getter('getOriginalEntity', { namespace: 'entity' }) originalEntity!: Entity;

    @Prop({ type: Array })
    rules;
  }
